<template>
    <el-container>
        <el-main>
            <el-row :gutter="10">
                <el-col :xs="24" :sm="12">
                    <el-card shadow="always" class="box-card">
                        <el-descriptions class="margin-top" title="产品团队" :column="1" border>
                            <template v-for="(itme, index, k) in systemInfo" :key="index">
                                <el-descriptions-item v-if="k > 7">
                                    <template #label>
                                        <div class="cell-item">
                                            {{ itme.name }}
                                        </div>
                                    </template>
                                    {{ itme.info }}
                                </el-descriptions-item>
                            </template>
                        </el-descriptions>
                    </el-card>
                </el-col>
                <el-col :xs="24" :sm="12">
                    <el-card shadow="always" class="box-card">
                        <el-descriptions class="margin-top" title="系统信息" :column="1" border>
                            <template v-for="(itme, index, k) in systemInfo" :key="index">
                                <el-descriptions-item v-if="k <= 7">
                                    <template #label>
                                        <div class="cell-item">
                                            {{ itme.name }}
                                        </div>
                                    </template>
                                    {{ itme.info }}
                                </el-descriptions-item>
                            </template>
                        </el-descriptions>
                    </el-card>
                </el-col>
            </el-row>
        </el-main>
    </el-container>
</template>

<script>
    import { getCurrentInstance, defineComponent, ref, computed } from 'vue'
    import { useOtherStore } from '@/store'
    import Cache from '@/utils/cache'
    import Api from '@/config/api'
    export default defineComponent({
        setup() {
            const StoreOther = useOtherStore()
            const systemInfo = computed(() => StoreOther.systemInfo)
            const { proxy } = getCurrentInstance()
        }
    })
</script>

<style>
    .card-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .text {
        font-size: 14px;
    }

    .item {
        margin-bottom: 18px;
    }

    .box-card .is-bordered-label{
        width: 170px;
    }
</style>
